import axiosClient from "../../api/axiosClient";
import customNotification from "../../components/notification";
import moment from "moment";

const addCaseStateMentModel = {
    state: [],
    reducers: {
        setData(state, payload) {
            return {...state, [payload.name]: payload.data,...payload };
        },
    },
    effects: (dispatch) => ({
        async addCaseData(payload) {
            await axiosClient.post('/content/up_add_cash_statement', payload).then(res => {
                if (res.data.status === 200) {
                    // getBalanceData(payload)
                    this.getAddCaseDataShow(payload)
                    customNotification(res.data.message, "success")
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        },
        async getAddCaseDataShow(payload) {
            await axiosClient.post('/content/add_cash_statement', payload).then(res => {
                if (res.data.status === 200) {
                   this.setData({ name: "addCaseStatement", data: res.data });
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        }
    }),
};

export default addCaseStateMentModel;